module.exports = __webpack_public_path__ + "static/media/COS_LES_3CHENES.47882e11.jpg";